// Strony szczegółów: w menu bocznym zostaje tylko "Powrót" i "Wyloguj".
// Dokąd wraca użytkownik ze strony szczegółów - na podstawie `state.from` przekazanego
// przy wejściu (patrz Row.jsx, NowyHandling, MagazynListPage). Brak wartości = Dashboard
// (tak wchodzą listy Import/Eksport/Tranzyt).
const BACK_TARGETS = {
  dashboard: { path: "/user", label: "Dashboard" },
  archive: { path: "/archive", label: "Archiwum odpraw" },
  tranzyt: { path: "/tranzyt", label: "Odprawy Tranzyt" },
  tranzytArchive: { path: "/archiveTranzyt", label: "Archiwum tranzyt" },
  history: { path: "/history", label: "Historia zmian" },
  magazynWarszawa: { path: "/magazynWarszawa", label: "Archiwum Odprawa Celna" },
  magazynWarszawaZwrotyIBledy: { path: "/magazynWarszawaZwrotyIBledy", label: "Zwroty i błędy" },
  magazynWarszawaHandling: { path: "/magazynWarszawaHandling", label: "Archiwum Handling" },
  raportMagazynWarszawa: { path: "/raportMagazynWarszawa", label: "Raport czasów" },
  magazynWarszawaNowyHandling: { path: "/magazynWarszawaNowyHandling", label: "Magazyn Warszawa" },
};

export const getDetailBack = (from) => BACK_TARGETS[from] || BACK_TARGETS.dashboard;

// Szczegoly wpisu KW: wejscie z listy KW, z Rejestru wnioskow albo z checklisty - strona wejsciowa
// przekazuje `returnPath` / `returnLabel` (np. "Powrót do RW"); brak = lista Kontroli wewnetrznej.
const getKwDetailBack = (state) => {
  const path =
    typeof state?.returnPath === "string" && state.returnPath.trim()
      ? state.returnPath
      : "/kontrolaWewnetrzna";
  if (path.startsWith("/rejestrWnioskow")) return { path, label: "Rejestr wniosków" };
  if (path.startsWith("/kontrolaWewnetrzna/szczegoly/")) return { path, label: "Szczegóły wpisu KW" };
  if (path === "/kontrolaWewnetrzna") return { path, label: "Kontrola wewnętrzna" };
  const label =
    typeof state?.returnLabel === "string"
      ? state.returnLabel.replace(/^Powrót do\s*/i, "").trim()
      : "";
  return { path, label: label || "Poprzednia strona" };
};

// Zwraca cel powrotu, jesli biezaca trasa jest strona szczegolow (inaczej null).
export const getBackTarget = (pathname, state, prevPath) => {
  if (pathname === "/form") return getFormBack(prevPath);
  if (pathname.startsWith("/detail/")) return getDetailBack(state?.from);
  if (pathname.startsWith("/rejestrWnioskow/") && !pathname.slice(17).includes("/")) {
    return { path: "/rejestrWnioskow", label: "Rejestr wniosków" };
  }
  if (pathname.startsWith("/kontrolaWewnetrzna/szczegoly/")) return getKwDetailBack(state);
  return null;
};

// Formularz "Dodaj zgłoszenie" (/form): wraca tam, skąd użytkownik wszedł (ostatnia strona
// spoza /form zapamiętana w ShellLayout). Etykieta z listy znanych pozycji menu.
const FORM_BACK_LABELS = {
  "/user": "Dashboard",
  "/tranzyt": "Odprawy Tranzyt",
  "/archive": "Archiwum odpraw",
  "/archiveTranzyt": "Archiwum tranzyt",
  "/magazynWarszawaNowyHandling": "Magazyn Warszawa",
  "/magazynWarszawaZwrotyIBledy": "Zwroty i błędy",
  "/magazynWarszawa": "Archiwum Odprawa Celna",
  "/magazynWarszawaHandling": "Archiwum Handling",
  "/magazynWarszawaLists": "Zarządzanie listą",
  "/raportMagazynWarszawa": "Raport czasów",
  "/rejestrWnioskow": "Rejestr wniosków",
  "/kontrolaWewnetrzna": "Kontrola wewnętrzna",
  "/traces": "Traces",
  "/history": "Historia zmian",
  "/calculator": "Kalkulator ilości spraw",
  "/calculatorZrealizowan&Przygotowane": "Kalkulator zrealizowane",
  "/raportCzasowOdpraw": "Raport czasów odpraw",
  "/list": "Listy",
  "/adminPanel": "Admin panel",
};

export const getFormBack = (prevPath) => {
  const path = prevPath || "/user";
  const base = path.split("?")[0];
  return { path, label: FORM_BACK_LABELS[base] || "Poprzednia strona" };
};
